/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Virtual_TourInputs */

const en_virtual_tour = /** @type {(inputs: Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3D Virtual Tour`)
};

const id_virtual_tour = /** @type {(inputs: Virtual_TourInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tur Virtual 3D`)
};

/** @type {(inputs: Virtual_TourInputs) => LocalizedString} */
const es_virtual_tour = en_virtual_tour;

/** @type {(inputs: Virtual_TourInputs) => LocalizedString} */
const fr_virtual_tour = en_virtual_tour;

/** @type {(inputs: Virtual_TourInputs) => LocalizedString} */
const de_virtual_tour = en_virtual_tour;

/** @type {(inputs: Virtual_TourInputs) => LocalizedString} */
const ja_virtual_tour = en_virtual_tour;

/** @type {(inputs: Virtual_TourInputs) => LocalizedString} */
const zh_virtual_tour = en_virtual_tour;

/** @type {(inputs: Virtual_TourInputs) => LocalizedString} */
const ar_virtual_tour = en_virtual_tour;

/** @type {(inputs: Virtual_TourInputs) => LocalizedString} */
const it_virtual_tour = en_virtual_tour;

/** @type {(inputs: Virtual_TourInputs) => LocalizedString} */
const ru_virtual_tour = en_virtual_tour;

/** @type {(inputs: Virtual_TourInputs) => LocalizedString} */
const pt_virtual_tour = en_virtual_tour;

/** @type {(inputs: Virtual_TourInputs) => LocalizedString} */
const ko_virtual_tour = en_virtual_tour;

/**
* | output |
* | --- |
* | "3D Virtual Tour" |
*
* @param {Virtual_TourInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const virtual_tour = /** @type {((inputs?: Virtual_TourInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Virtual_TourInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_virtual_tour(inputs)
	if (locale === "es") return es_virtual_tour(inputs)
	if (locale === "fr") return fr_virtual_tour(inputs)
	if (locale === "de") return de_virtual_tour(inputs)
	if (locale === "ja") return ja_virtual_tour(inputs)
	if (locale === "zh") return zh_virtual_tour(inputs)
	if (locale === "ar") return ar_virtual_tour(inputs)
	if (locale === "id") return id_virtual_tour(inputs)
	if (locale === "it") return it_virtual_tour(inputs)
	if (locale === "ru") return ru_virtual_tour(inputs)
	if (locale === "pt") return pt_virtual_tour(inputs)
	return ko_virtual_tour(inputs)
});